import { type DPC, type Options } from "@depict-ai/dpc";
import { isCentraEvent, selectionItemToGTAGProduct } from "../gtm";
import type { Adapter } from "../types";

let dpc: DPC | undefined;

export const getDPC = async (merchant: string, options?: Options) => {
  if (!dpc) {
    const DPC = await import("@depict-ai/dpc").then((mod) => mod.DPC);
    dpc = new DPC(merchant, options);
  }

  return dpc;
};

export const depictAdapter = (merchant: string, options?: Options): Adapter => {
  return {
    consume: (e) => {
      if (isCentraEvent(e)) {
        if ("token" in e.data) {
          dpc?.setSessionId(e.data.token);
          if (e.data.location?.country) dpc?.setMarket(e.data.location.country);
        }

        switch (e.event) {
          case "add_to_cart":
            const product_id = e.data.selection?.items
              ?.find((item) => item.item === e.additionalData.item_id)
              ?.item?.split("-")
              .pop();

            if (product_id) {
              dpc?.sendAddToCartEvent({ product_id });
            }
            break;

          case "purchase":
            dpc?.sendPurchaseEvent({
              transaction_id: e.data.order!,
              currency: e.data.currency!,
              items: e.data.items?.map(selectionItemToGTAGProduct)! as any,
            });
            break;
          case "select_product_size":
            dpc?.setProductId(e.additionalData.depictProductId);
        }

        return;
      }
    },
    load: async () => {
      await getDPC(merchant, options);
    },
  };
};
